export async function getMediaStream(constraints: MediaStreamConstraints = { audio: true, video: true }) {
  function exactify(c: MediaTrackConstraints | boolean | undefined) {
    if (!c || typeof c === "boolean") return c;
    const deviceId = (c as any).deviceId;
    if (typeof deviceId === "string") {
      return {
        ...c,
        deviceId: { exact: deviceId } as ConstrainDOMString
      };
    }
    return c;
  }

  const normalized: MediaStreamConstraints = {
    audio: exactify(constraints.audio) as any,
    video: exactify(constraints.video) as any
  };

  try {
    return await navigator.mediaDevices.getUserMedia(normalized);
  } catch {
    return await navigator.mediaDevices.getUserMedia(constraints);
  }
}
